import { Component } from '@angular/core'

@Component({
    selector: 'app-section-loader',
    templateUrl: './section-loader.component.html',
    styleUrls: ['./section-loader.component.scss'],
    standalone: true
})
export class SectionLoaderComponent { }
